import React, { PureComponent } from 'react';
import connect from 'react-redux/es/connect/connect';
import { withRouter } from 'react-router-dom';
import Toast from '../../components/Toasts/Toast';

type Props = {};

class Topo extends PureComponent<Props> {
  constructor(props) {
    super(props);
    this.state = {
      activeitem: {},
    };
    document.addEventListener('mousedown', this.hideMenu);
  }
  hideMenu = () => {
    this.setState({ activeitem: -1 });
  };
  closeMenus = (e) => {
    e.preventDefault();
  };
  setActive = (id: number) => {
    this.setState({ activeitem: id });
  };

  handleBack = () => {
    this.props.history.goBack();
  };

  render() {
    const { activeitem } = this.state;
    const { user, mainTitle, subTitle, canBack } = this.props;
    return (
      <React.Fragment>
        <Toast />

        <div className="header" onMouseOut={this.closeMenus}>
          <div className="container-fluid">
            <div className="row linhaTopo">
              <div className="navTopo col-lg-12 d-flex align-items-center">
                {/* {!canBack && ( */}
                <div className="menu d-flex align-items-center hamburger-content sidebar-toggle">
                  <div className="menu hamburger">
                    <span className="menu line" />
                    <span className="menu line" />
                    <span className="menu line" />
                  </div>
                </div>
                {/* )} */}
                {canBack && (
                  <div
                    className="action bt-voltar d-flex align-items-center"
                    onClick={this.handleBack}
                  >
                    <i className="icon-seta_02" />
                  </div>
                )}

                <div className="flex-grow-1 flex-column titulo-topo">
                  <h1 className="titulo ml-4 mb-0">
                    {mainTitle ? mainTitle : 'Olá bem vindo(a)'}
                  </h1>
                  <h1 className="sub-titulo ml-4 mb-0">
                    <b>{subTitle ? subTitle : user.nomeExibicao}</b>
                  </h1>
                </div>
                <div className="logo w-25">
                  <div className="logoMarca" style={{ minHeight: 120 }}></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  const { mainTitle, subTitle, canBack } = state.pageTitle;

  return {
    user,
    mainTitle,
    subTitle,
    canBack,
  };
}

export default connect(mapStateToProps)(withRouter(Topo));
